/**
 * Whether the browser reading this is a phone.
 *
 * Its own module, importing nothing, for two reasons. The screens that ask
 * are the router and the front page's daily card, and neither should have to
 * pull a screen in to ask a question about the device. And it is the half of the gate worth a test: screens/phone-gate.ts
 * reaches chrome.ts, which asks the API for its version at import time, and a
 * test cannot bundle that.
 */

// What a phone is, for this purpose. Two questions, both of which have to say
// yes.
//
// A coarse pointer is the half that matters: it is a device whose primary
// input is a finger, which is what MegaMek's client has no answer for. It is
// also what keeps a desktop window dragged narrow out of this — that is a
// mouse in front of a small viewport, and it can play.
//
// The size is the half that lets a tablet through. A phone is small in one
// dimension whichever way it is held, so both are asked: 390x844 is narrow
// upright and short on its side, while an iPad in landscape is neither.
const COARSE = "(pointer: coarse)";
const NARROW = "(max-width: 48rem)";
const SHORT = "(max-height: 30rem)";

/**
 * The answer, at the moment it is asked.
 *
 * Read at the moment a screen is chosen rather than watched: rotating a phone
 * does not stop it being one, and there is no size a phone can be resized to
 * that would make a match playable on it.
 *
 * Guarded for a missing matchMedia, because this runs before anything else
 * the play path does and the wrong answer to fail with is "no phones may
 * play".
 */
export function isPhone(): boolean {
  if (!window.matchMedia) return false;
  if (!window.matchMedia(COARSE).matches) return false;
  return window.matchMedia(NARROW).matches || window.matchMedia(SHORT).matches;
}
